import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isResourceCategorySlug } from '../../constants/resources';
import { isProjectCategorySlug } from '../../constants/projects';

export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const category = new URLSearchParams(search).get('category');
    if (pathname === '/resources' && isResourceCategorySlug(category)) {
      return;
    }
    if (pathname === '/projects' && isProjectCategorySlug(category)) {
      return;
    }
    if (hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, search, hash]);

  return null;
};
